import {
  Grid,
  TextField,
  Box,
  Button,
  InputAdornment,
  useTheme,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useProductCatalogContext } from "@/context/ProductCatalogContext";

export const ProductSearchBar = () => {
  const { search, setSearch } = useProductCatalogContext();
  const theme = useTheme();

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const searchValue = formData.get("searchProducts") as string;
    setSearch(searchValue);
  };

  return (
    <Grid
      id="search-bar"
      data-cypress="products-search-bar"
      container
      alignItems="center"
      margin="auto"
      columns={{ xs: 6 }}
      sx={{
        position: "fixed",
        top: { xs: "0", sm: "82px" },
        left: 0,
        right: 0,
        zIndex: 1000,
        textAlign: { xs: "center", md: "left" },
        width: { xs: "100%", sm: 560, md: 840, lg: 1140 },
      }}
    >
      <Grid
        size={{ xs: 6 }}
        sx={{
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          padding: "12px",
          display: "flex",
          alignItems: "center",
          borderRadius: 3,
          border: "1px solid rgba(0, 0, 0, 0.08)",
        }}
      >
        <Box
          component="form"
          onSubmit={handleSearchSubmit}
          sx={{ display: "flex", alignItems: "center", width: "100%" }}
        >
          <TextField
            data-cypress="products-search-input"
            variant="outlined"
            name="searchProducts"
            placeholder="Search..."
            id="brand-search"
            defaultValue={search || ""}
            sx={{
              flexGrow: 1,
              "& .MuiOutlinedInput-root": {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  borderColor: "primary.main",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
                },
                "&.Mui-focused": {
                  borderColor: "primary.main",
                  boxShadow: `0 4px 12px ${theme.palette.secondary.main}33`,
                },
              },
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              },
            }}
          />
          <Button
            data-cypress="products-search-button"
            type="submit"
            variant="contained"
            sx={{
              height: "56px",
              minWidth: "56px",
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              color: "white",
              background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark || theme.palette.secondary.main} 100%)`,
              boxShadow: `0 4px 12px ${theme.palette.secondary.main}4D`,
              border: "1px solid rgba(255, 255, 255, 0.2)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                background: `linear-gradient(135deg, ${theme.palette.secondary.dark || theme.palette.secondary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                transform: "scale(1.03)",
                boxShadow: `0 6px 16px ${theme.palette.secondary.main}66`,
              },
              "&:active": {
                transform: "translateY(0)",
              },
            }}
          >
            Search
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};
